import React from 'react';
import c from 'classnames';
import { Route, Switch, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Header } from '../header';
import {
  Faqs,
  HouseRules,
  ItemViewPage,
  ItemsListViewPage,
  PrivacyAndCookies,
  Tag,
  ItemEmbeddedViewPage,
} from '../pages';
import {
  selectNightMode,
  selectShowNsfw,
} from '../../ducks';
import { NotFound } from '../NotFound';
import { UploadForm } from '../upload';
import { Menu, SettingsMenu, HistoryMenu } from '../menu';
import { ContactForm } from '../contactform';
import { LoginPage } from '../auth';
import { Footer } from '../footer';
import { Modal } from '../modal';
import { StemPage } from '../stemform';
import { Deluxe } from '../deluxe';
import { useItemViewSearchParams, ThemeContext } from '../commons';
import { ITEM_EMBEDDED_PAGE_PATH, ITEM_PAGE_PATH, LIST_PAGE_PATH, TAG_PAGE_PATH } from '../paths';

export const routes = [
  {
    path: [LIST_PAGE_PATH],
    exact: true,
    component: ItemsListViewPage,
    disableFooter: () => true,
    serverFetch: ItemsListViewPage.serverFetch,
  },

  {
    path: [ITEM_PAGE_PATH],
    exact: true,
    component: ItemViewPage,
    disableFooter: () => false,
    serverFetch: ItemViewPage.serverFetch,
  },
  {
    path: TAG_PAGE_PATH,
    exact: true,
    component: Tag,
    disableFooter: () => true,
    serverFetch: Tag.serverFetch,
  },
  { path: '/huisregels/', exact: true, component: HouseRules },
  { path: '/veelgestelde-vragen/', exact: true, component: Faqs },
  { path: '/privacy/', exact: true, component: PrivacyAndCookies },
  { path: '/(login|nslogin)', exact: true, component: LoginPage },
  

  // legacy redirect
  {
    path: '/:view(mediabase|embed)/:id1/:id2/(.*)?',
    exact: false,
    // eslint-disable-next-line react/display-name
    render: ({ match: { params: { view, id1, id2 } } }) =>
      <Redirect to={`/${view === 'embed' ? view : 'item'}/${id1}_${id2}`}/>,
  },
  { path: '/stem/', exact: true, component: StemPage },

  // not matched path
  { path: '*', exact: true, component: NotFound },
];

export const links = [
  { title: 'Home', path: '/' },
  { title: 'Toppers', path: '/toppers' },
  { title: 'Huisregels', path: '/huisregels/' },
  { title: 'Privacy & Cookies', path: '/privacy/' },
  { title: 'Floppers', path: '/floppers' },
];

export const Layout = ({ staticContext }) => {
  const isNightMode = useSelector(selectNightMode);
  const showNsfw = useSelector(selectShowNsfw);
  const { selectedId } = useItemViewSearchParams();

  return (
    <Switch>
      <Route exact path={ITEM_EMBEDDED_PAGE_PATH} component={ItemEmbeddedViewPage}/>
      <Route exact path={'/deluxe/:periodParam?'} component={Deluxe} />
      <Route exact path="/*" render={() =>
        <div className={c('wrapper', { ['nightmode']: isNightMode })}>
          <ThemeContext.Provider value={{
            isNightMode,
          }}>
            <UploadForm />
            <Menu
              links={links}
              showNsfw={showNsfw}
            />
            <SettingsMenu />
            <HistoryMenu />
            <ContactForm />
            <div>
              <Header modalActive={!!selectedId}/>
              <div className={c({ 'container': true }, 'content_container')}>
                {!!selectedId && <Modal staticContext={staticContext}/>}
                <Switch>
                  {routes.map(({ path, component, render, exact }) => (
                    component ?
                      <Route exact={exact} path={path} component={component} key={path} /> :
                      <Route exact={exact} path={path} render={render} key={path} />
                  ))}
                </Switch>
              </div>
              <Footer routes={routes} />
            </div>
          </ThemeContext.Provider>
        </div>
      }/>
    </Switch>
  );
};

Layout.Routes = [{
  path: ITEM_EMBEDDED_PAGE_PATH, component: ItemEmbeddedViewPage, serverFetch: ItemEmbeddedViewPage.serverFetch,
}].concat(routes);
